import { styled } from '../../Utilities';
import { OverlayBase } from './Overlay.base';
import { getStyles } from './Overlay.styles';
export var Overlay = styled(OverlayBase, getStyles, undefined, {
    scope: 'Overlay'
});
//# sourceMappingURL=Overlay.js.map